import { toast } from 'react-toastify';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { winnreAuth } from '../../utils/axios';
import useAxios from '../../Hooks/use-axios';

const statusMapping = {
    All: '',
    'Order Placed': 'CREATED',
    Shipped: 'DISPATCHED',
    Delivered: 'DELIVERED'
};
const useData = (orderStatus) => {
    const [orders, setOrders] = useState([
        {
            dealDisplayImageUrl: '',
            dealTitle: 'Y=Test',
            deliveryDetails: {
                trackingId: 1,
                customerName: 'MB',
                mobileNumber: 8898,
                shippingAddress: {
                    country: 'India',
                    pincode: 110092,
                    state: 'Delhi',
                    city: 'Delhi',
                    lin1: '112',
                    line2: 'cv',
                    userName: 'mb'
                }
            },
            payment: { amount: 1123132 }
        }
    ]);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [deals, setDeals] = useState([]);
    const { isLoading: loadingDeals, sendRequest: fetchDeals } = useAxios();

    useEffect(() => {
        if (isAuthenticated) {
            getAllOrders();
        }
    }, [isAuthenticated, orderStatus]);

    const getAllOrders = () => {
        setLoadingOrders(true);
        const backendStatus = statusMapping[orderStatus];
        winnreAuth({
            method: 'GET',
            url: `/winnre/user/reward-redemption${
                orderStatus === 'All' ? '' : `?&statuses=${backendStatus}`
            }`
        })
            .then((res) => {
                // console.log('all orders', res);
                setLoadingOrders(false);
                setOrders(res?.content);
            })
            .catch((err) => {
                // console.log(err);
                toast.error('Something went wrong. Please try again');
            });
    };

    useEffect(() => {
        getOffers();
    }, []);

    const getOffers = () => {
        fetchDeals(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&rewardsPage=true`,
                method: 'get',
                isFormData: true
            },
            (res) => {
                // console.log('ordersPage Deals', res?.content);
                setDeals(res?.content);
            }
        );
    };

    return {
        orders,
        loadingOrders,
        deals
    };
};
export default useData;
